import { Type } from '~/types/survey/types';

export const SURVEY_TYPE_NPS: Type = 'nps';
export const SURVEY_TYPE_RADIO_LIST: Type = 'radio-list';
export const SURVEY_DISMISS_TIMEOUT = 3000;
export const MD_BREAKPOINT_MAX_WIDTH = 768;
